import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const Transcript = ({
  size = 14,
  title = 'Transcript',
  fill = colors.boulder,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-transcript"
      height={height}
      viewBox="0 0 25 29"
    >
      {Boolean(title) && <title>{title}</title>}
      <path
        d="M23.68,0H1.32A1.31,1.31,0,0,0,0,1.27V27.73A1.32,1.32,0,0,0,1.32,29H23.68A1.31,1.31,0,0,0,25,27.73V1.27A1.32,1.32,0,0,0,23.68,0ZM22.31,2.54V26.45H2.68V2.54Z"
        fill={fill}
      />
      <path d="M7.31,9.25H17.79a1.27,1.27,0,1,0,0-2.54H7.31a1.27,1.27,0,1,0,0,2.54Z" fill={fill} />
      <path d="M7.31,15.66H17.79a1.28,1.28,0,1,0,0-2.55H7.31a1.28,1.28,0,1,0,0,2.55Z" fill={fill} />
      <path
        d="M17.8,19.36H7.31a1.28,1.28,0,0,0-1.26,1.31,1.29,1.29,0,0,0,1.26,1.24H17.79a1.28,1.28,0,0,0,0-2.55Z"
        fill={fill}
      />
    </svg>
  );
};
